// extracted by mini-css-extract-plugin
export default {"alertButton":"npm2qQyR","alertText":"y0HOeJc7"};